var map = {
	"./COL.jpg": 600,
	"./GoogleResearch.png": 601,
	"./IBMIRL.jpg": 602,
	"./ISRO.png": 603,
	"./MicrosoftResearch.png": 604,
	"./accenturelabs.png": 605,
	"./bosch.png": 606,
	"./codechef.png": 607,
	"./dst.png": 608,
	"./earthwatch.png": 609,
	"./exafluence.png": 610,
	"./rlf.jpg": 611,
	"./waterloo.jpg": 612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 599;